(()=>{
  const WIDGET_ID='7831057d-42ac-4a07-8a14-15b762660f33';
  const REVIEWS_URL='https://www.google.com.br/search?ibp=gwp;0,7&q=Pedalokos+-+Loja+de+Bicicletas+mais+premiada+do+Sul+do+Brasil&ludocid=504865409983472975&lsig=AB86z5U5kRHYTSPdNyrrLkLzsUiV#lkt=LocalPoiReviews&lpg=cid:CgIgAQ%3D%3D';
  const WIDGET_URL='https://featurable.com/api/v1/widgets/'+WIDGET_ID;
  const SUMMARY_CACHE_KEY='pedalokos-google-reviews-summary';

  const age=value=>{
    if(!value)return'';
    const date=new Date(value);
    if(Number.isNaN(date.getTime()))return'';
    const days=Math.max(0,Math.floor((Date.now()-date.getTime())/86400000));
    if(days<1)return'Hoje';
    if(days<7)return days+' dias atrás';
    if(days<30){const weeks=Math.max(1,Math.floor(days/7));return weeks+' semana'+(weeks>1?'s':'')+' atrás';}
    if(days<365){const months=Math.max(1,Math.floor(days/30.44));return months+' '+(months===1?'mês':'meses')+' atrás';}
    const years=Math.max(1,Math.floor(days/365.25));
    return years+' ano'+(years>1?'s':'')+' atrás';
  };

  const clean=value=>{
    const text=String(value||'').trim();
    const lower=text.toLowerCase();
    const marks=['(translated by google)','translated by google','(traduzido pelo google)','traduzido pelo google'];
    let cut=-1;
    for(const mark of marks){
      const pos=lower.indexOf(mark);
      if(pos>=0&&(cut<0||pos<cut))cut=pos;
    }
    return(cut>=0?text.slice(0,cut):text).trim();
  };

  const normalize=review=>({
    name:review?.reviewer?.displayName||review?.authorName||'Cliente Pedalokos',
    avatar:review?.reviewer?.profilePhotoUrl||review?.profilePhotoUrl||'',
    rating:Number(review?.starRating??review?.rating??5)||5,
    text:clean(review?.comment??review?.text??''),
    date:review?.createTime||review?.updateTime||review?.createdAt||''
  });

  const stars=n=>{
    const wrap=document.createElement('span');
    wrap.className='pdlrc__stars';
    for(let i=1;i<=5;i++){
      const star=document.createElement('span');
      star.className='pdlrc__star'+(i<=Math.round(Number(n)||0)?' on':'');
      star.textContent='★';
      wrap.appendChild(star);
    }
    return wrap;
  };

  const card=(review,url)=>{
    const el=document.createElement('article');
    el.className='pdlrc__card';
    el.appendChild(stars(review.rating));

    const person=document.createElement('div');
    person.className='pdlrc__person';
    const avatar=document.createElement('div');
    avatar.className='pdlrc__avatar';
    if(review.avatar){
      const image=document.createElement('img');
      image.src=review.avatar;
      image.alt='';
      image.loading='lazy';
      image.referrerPolicy='no-referrer';
      image.onerror=()=>{avatar.replaceChildren();avatar.textContent=(review.name||'?').charAt(0).toUpperCase();};
      avatar.appendChild(image);
    }else{
      avatar.textContent=(review.name||'?').charAt(0).toUpperCase();
    }

    const info=document.createElement('div');
    info.style.minWidth='0';
    const name=document.createElement('strong');
    name.className='pdlrc__name';
    name.textContent=review.name;
    const date=document.createElement('span');
    date.className='pdlrc__date';
    date.textContent=age(review.date);
    info.append(name,date);
    person.append(avatar,info);
    el.appendChild(person);

    const body=document.createElement('p');
    body.className='pdlrc__body';
    body.textContent=review.text;
    el.appendChild(body);

    const more=document.createElement('a');
    more.className='pdlrc__more';
    more.href=url;
    more.target='_blank';
    more.rel='noopener noreferrer';
    more.textContent='Ver mais no Google';
    more.hidden=true;
    el.appendChild(more);

    const foot=document.createElement('div');
    foot.className='pdlrc__foot';
    const source=document.createElement('span');
    source.textContent='Google';
    foot.appendChild(source);
    el.appendChild(foot);
    return el;
  };

  const init=root=>{
    if(!root||root.dataset.pdlV4==='1')return;
    root.dataset.pdlV4='1';

    const limit=Number(root.dataset.limit||15);
    const loading=root.querySelector('[data-loading]');
    const error=root.querySelector('[data-error]');
    const summary=root.querySelector('[data-summary]');
    const ratingEl=root.querySelector('[data-rating]');
    const summaryStars=root.querySelector('[data-summary-stars]');
    const countEl=root.querySelector('[data-count]');
    const custom=root.querySelector('[data-custom]');
    const track=root.querySelector('[data-track]');
    const view=root.querySelector('[data-view]');
    const profileLink=root.querySelector('[data-profile]');
    if(profileLink&&!profileLink.getAttribute('href'))profileLink.href=REVIEWS_URL;
    const badge=document.querySelector('[data-pdlrc-badge]');

    let timeoutId=0;
    let delivered=false;

    const renderSummary=(average,count)=>{
      const safeAverage=Number(average);
      if(!Number.isFinite(safeAverage)||safeAverage<=0)return;
      if(ratingEl)ratingEl.textContent=safeAverage.toLocaleString('pt-BR',{minimumFractionDigits:1,maximumFractionDigits:1});
      if(summaryStars)summaryStars.replaceChildren(stars(safeAverage));
      if(countEl){
        const safeCount=Number(count);
        countEl.textContent=Number.isFinite(safeCount)&&safeCount>0
          ?safeCount.toLocaleString('pt-BR')+' avaliações no Google'
          :'Avaliações do Google';
      }
      if(summary)summary.hidden=false;
      if(badge){
        const badgeRating=badge.querySelector('[data-badge-rating]');
        const badgeStars=badge.querySelector('[data-badge-stars]');
        const badgeCount=badge.querySelector('[data-badge-count]');
        if(badgeRating)badgeRating.textContent=safeAverage.toLocaleString('pt-BR',{minimumFractionDigits:1,maximumFractionDigits:1});
        if(badgeStars)badgeStars.textContent='★★★★★';
        if(badgeCount){
          const n=Number(count);
          badgeCount.textContent=Number.isFinite(n)&&n>0?'Leia nossas '+n.toLocaleString('pt-BR')+' avaliações':'Veja nossas avaliações';
        }
        badge.hidden=false;
      }
    };

    renderSummary(root.dataset.fallbackRating,root.dataset.fallbackCount);
    try{
      const cached=JSON.parse(localStorage.getItem(SUMMARY_CACHE_KEY)||'null');
      if(cached&&Date.now()-cached.savedAt<7*86400000)renderSummary(cached.average,cached.count);
    }catch(err){console.warn('[PDL reviews cache]',err);}

    const loadSummary=()=>fetch(WIDGET_URL,{headers:{accept:'application/json'},cache:'no-store'})
      .then(response=>{
        if(!response.ok)throw new Error('Featurable HTTP '+response.status);
        return response.json();
      })
      .then(data=>{
        if(!data?.success)throw new Error('Resposta inválida da Featurable');
        renderSummary(data.averageRating,data.totalReviewCount);
        try{localStorage.setItem(SUMMARY_CACHE_KEY,JSON.stringify({average:data.averageRating,count:data.totalReviewCount,savedAt:Date.now()}));}catch(err){console.warn('[PDL reviews cache]',err);}
      })
      .catch(err=>{
        console.warn('[PDL reviews summary]',err);
      });

    loadSummary();

    const showError=err=>{
      if(delivered)return;
      console.warn('[PDL reviews v4]',err);
      if(loading)loading.hidden=true;
      if(error)error.hidden=false;
      if(custom)custom.hidden=true;
    };

    const receive=raw=>{
      if(!Array.isArray(raw)||!raw.length)return;
      const available=raw.map(normalize).filter(review=>review.text&&review.rating>=4&&review.rating<=5);
      const reviews=available.slice(0,limit);
      if(!reviews.some(review=>review.rating===4)){
        const fourStar=available.find(review=>review.rating===4);
        if(fourStar&&reviews.length)reviews.splice(Math.min(2,reviews.length-1),1,fourStar);
      }
      if(!reviews.length)return;
      delivered=true;
      if(timeoutId)clearTimeout(timeoutId);
      track.replaceChildren(...reviews.map(review=>card(review,profileLink?.href||REVIEWS_URL)));
      if(loading)loading.hidden=true;
      if(error)error.hidden=true;
      if(custom)custom.hidden=false;
      root.dataset.ready='1';
      requestAnimationFrame(updateMore);
    };

    const updateMore=()=>{
      track?.querySelectorAll('.pdlrc__card').forEach(el=>{
        const body=el.querySelector('.pdlrc__body');
        const more=el.querySelector('.pdlrc__more');
        if(body&&more)more.hidden=body.scrollHeight<=body.clientHeight+2;
      });
    };
    window.addEventListener('resize',updateMore,{passive:true});

    const step=()=>{
      const first=track?.firstElementChild;
      return first?first.getBoundingClientRect().width+11:(view?.clientWidth||300);
    };
    const prev=root.querySelector('[data-prev]');
    const next=root.querySelector('[data-next]');
    if(prev&&view)prev.onclick=()=>view.scrollBy({left:-step(),behavior:'smooth'});
    if(next&&view)next.onclick=()=>view.scrollBy({left:step(),behavior:'smooth'});

    const mount=document.createElement('div');
    mount.hidden=true;
    mount.setAttribute('aria-hidden','true');
    mount.className='pdlrc__featurable-data-bridge';
    root.appendChild(mount);

    const start=async()=>{
      try{
        const [reactMod,domMod,reviewsMod]=await Promise.all([
          import('https://esm.sh/react@18.3.1'),
          import('https://esm.sh/react-dom@18.3.1/client'),
          import('https://esm.sh/react-google-reviews@1.9.0?deps=react@18.3.1,react-dom@18.3.1')
        ]);
        const React=reactMod.default||reactMod;
        const createRoot=domMod.createRoot;
        const ReactGoogleReviews=reviewsMod.ReactGoogleReviews;
        if(!React||!createRoot||!ReactGoogleReviews)throw new Error('Biblioteca oficial não carregou');

        const Capture=props=>{
          React.useEffect(()=>{receive(props.reviews);},[props.reviews]);
          return null;
        };
        const renderer=reviews=>React.createElement(Capture,{reviews});
        const reactRoot=createRoot(mount);
        reactRoot.render(React.createElement(ReactGoogleReviews,{
          layout:'custom',
          featurableId:WIDGET_ID,
          renderer,
          hideEmptyReviews:true,
          disableTranslation:true,
          structuredData:false,
          loadingMessage:null,
          errorMessage:null
        }));
        root._pdlReviewsReactRoot=reactRoot;
        timeoutId=window.setTimeout(()=>showError(new Error('Tempo limite ao receber avaliações')),18000);
      }catch(err){
        showError(err);
      }
    };

    start();
  };

  const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    for(const entry of entries){
      if(!entry.isIntersecting)continue;
      observer.unobserve(entry.target);
      init(entry.target);
    }
  },{rootMargin:'400px 0px'}):null;
  const boot=()=>document.querySelectorAll('[data-pdlrc]').forEach(root=>{
    if(root.dataset.pdlQueued==='1'||root.dataset.pdlV4==='1')return;
    root.dataset.pdlQueued='1';
    if(observer)observer.observe(root);
    else init(root);
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();
